import { z } from 'zod';

/** Mesmas regras do backend (PASSWORD_RULES). */
export const passwordSchema = z
  .string()
  .min(8, 'A senha deve ter pelo menos 8 caracteres')
  .max(128, 'Senha muito longa')
  .regex(/^(?=.*[a-zA-Z])(?=.*\d).+$/, 'A senha deve conter letras e números');

export const emailSchema = z
  .string()
  .trim()
  .min(1, 'Informe o e-mail')
  .email('E-mail inválido')
  .max(254);

export const optionalString = (max = 200) =>
  z.string().trim().max(max).optional().or(z.literal(''));
